import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

/**
 *
 * @param root0
 * @param root0.value
 * @param root0.className
 * @param root0.noDay
 * @param root0.noTime
 * @param root0.noSeconds
 * @param root0.noRelative
 * @param root0.aligned
 * @returns {JSX} RenderDateWithFromTime
 */
function RenderDateWithFromTime({ value, className = '', noDay = false, noTime = false, noSeconds = false, noRelative = false, aligned = false }) {
    if (!value) {
        return null;
    }
    const { i18n } = useTranslation();
    const lang = i18n.resolvedLanguage;

    // If value isn't ISO string, uses milliseconds as value to create luxon date
    let luxonDate;
    if (typeof value === 'string') {
        luxonDate = DateTime.fromISO(value.replace(' ', 'T'), { locale: lang });
    } else {
        luxonDate = DateTime.fromMillis(value, { locale: lang });
    }

    // If noDay is true, adjust luxonDate formatting to internationalized MM/YY
    let formattedDate;
    if (noDay) {
        // Use Intl.DateTimeFormat for internationalization
        const locale = lang || 'en-US';
        formattedDate = new Intl.DateTimeFormat(locale, {
            year: '2-digit',
            month: '2-digit'
        }).format(luxonDate.toJSDate());
    } else {
        formattedDate = luxonDate.toLocaleString(
            noTime ? DateTime.DATE_SHORT :
                noSeconds ? DateTime.DATETIME_SHORT
                    : DateTime.DATETIME_SHORT_WITH_SECONDS
        );
    }

    return (
        <div className={className}>
            <div>
                <span className={aligned || noRelative ? 'whitespace-nowrap' : 'whitespace-nowrap text-xs'}>
                    {formattedDate}
                </span>
                {aligned && !noRelative && <span className='ml-2'>{luxonDate.toRelative()}</span>}
            </div>
            {!aligned && !noRelative && luxonDate.toRelative()}
        </div>
    );
}

RenderDateWithFromTime.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    className: PropTypes.string,
    noDay: PropTypes.bool,
    noTime: PropTypes.bool,
    aligned: PropTypes.bool,
    noSeconds: PropTypes.bool,
    noRelative: PropTypes.bool
};

export default RenderDateWithFromTime;